// extracted by mini-css-extract-plugin
export var actionText = "_r0-4";
export var container = "_r0-0";
export var leftSection = "_r0-1";
export var rightSection = "_r0-2";
export var settingsButton = "_r0-6";
export var settingsIcon = "_r0-7";
export var shortcut = "_r0-5";
export var shortcutGroup = "_r0-3";